(function ($) {

    // $.proofguide('/wp-content/themes/pp-v1.2-children/melissa-haugh/resources/guide.jpg');

})(jQuery);

